module.exports = __webpack_public_path__ + "static/media/hip.337a1311.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/hip.jpg
// module id = 31
// module chunks = 0